import React from 'react';
import { FlameIcon } from '../icons/SalesIcons';
interface SectionDividerProps {
  variant?: 'flame' | 'line' | 'ornament';
  className?: string;
}
export function SectionDivider({
  variant = 'flame',
  className = ''
}: SectionDividerProps) {
  if (variant === 'flame') {
    return <div className={`flex items-center justify-center gap-4 py-8 ${className}`} data-id="element-428">
        <div className="h-px w-16 md:w-32 bg-gradient-to-r from-transparent to-[#C4A882]" data-id="element-429" />
        <FlameIcon size={32} className="text-[#C4A882]" data-id="element-430" />
        <div className="h-px w-16 md:w-32 bg-gradient-to-l from-transparent to-[#C4A882]" data-id="element-431" />
      </div>;
  }
  if (variant === 'line') {
    return <div className={`py-8 ${className}`} data-id="element-432">
        <div className="h-px w-full max-w-md mx-auto bg-gradient-to-r from-transparent via-[#C4A882] to-transparent" data-id="element-433" />
      </div>;
  }
  // Ornament variant
  return <div className={`flex items-center justify-center py-8 ${className}`} data-id="element-434">
      <svg width="200" height="24" viewBox="0 0 200 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="text-[#C4A882]" data-id="element-435">
        <path d="M0 12H80M120 12H200" stroke="currentColor" strokeWidth="1" data-id="element-436" />
        <circle cx="100" cy="12" r="4" fill="currentColor" data-id="element-437" />
        <circle cx="88" cy="12" r="2" fill="currentColor" data-id="element-438" />
        <circle cx="112" cy="12" r="2" fill="currentColor" data-id="element-439" />
        <path d="M94 6C94 6 97 9 100 9C103 9 106 6 106 6" stroke="currentColor" strokeWidth="1" fill="none" data-id="element-440" />
        <path d="M94 18C94 18 97 15 100 15C103 15 106 18 106 18" stroke="currentColor" strokeWidth="1" fill="none" data-id="element-441" />
      </svg>
    </div>;
}